import styled from "styled-components";
//MISC
import { DEVICE_TYPE, MARGIN, SIZE } from "constants/variables";
//ASSETS
import cursorIcon from "assets/img/Cursor.png";

export const ProjectsContainer = styled.div`
  padding-block: calc(100px + ${SIZE.max80}) 0;
`;

export const TitleSectionWrapper = styled.div`
  padding-inline: ${SIZE.max220};

  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    padding-inline: ${SIZE.max24};
  }
`;

export const HeaderSectionWrapper = styled.div`
  padding-inline: ${SIZE.max220};

  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    padding-inline: 0;
  }
`;

export const ContentSectionWrapper = styled.div`
  padding-inline: ${SIZE.max220};

  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    padding-inline: ${SIZE.max24};
  }
`;

export const BackToWrapper = styled.div<{ biggerCursor?: boolean }>`
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: ${MARGIN.max10};

  opacity: 0.5;
  transition: 0.3s ease-in-out;
  &:hover {
    opacity: 0.8;
    transition: 0.3s ease-in-out;
  }
`;
export const BackToImage = styled.img`
  margin-top: 4px;
  margin-right: 8px;
  width: 10px;
  height: 16px;
`;

export const BackToButton = styled.div`
  border: none;
  margin-bottom: ${MARGIN.max6};
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
`;

export const InputContainer = styled.div`
  width: 100%;
  margin-block: ${MARGIN.fix24};
  z-index: 100000;
`;

export const ImgStyled = styled.img``;

export const TitleWrapper = styled.div`
  margin-top: 8px;
  margin-bottom: 24px;
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    margin-top: 16px;
    margin-bottom: 16px;
  }
`;

export const ProjectCardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(${SIZE.max400}, 1fr));
  gap: ${SIZE.max24};
  padding-block: ${SIZE.max18} ${SIZE.max40};

  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
  }

  @media (max-width: ${DEVICE_TYPE.mobile}) {
  }
`;

export const ProjectCardWrapper = styled.div`
  width: 100%;
  height: ${SIZE.max400};
`;
export const NoDataContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  padding: ${SIZE.max32};
`;

export const SvgContainer = styled.div`
  height: auto;
  width: auto;
  margin-bottom: ${MARGIN.max32};
  opacity: 0.4;
  > svg {
    height: ${SIZE.max220};
    width: ${SIZE.max220};
  }
`;
